import { signal } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { Stepper } from 'primeng/stepper';
import { StepComponent } from '../components/step/step.component';


export class StepAccessChecker {
  public readonly maxStepIndexVisited = signal(0);
  private steps: StepComponent[] = []

  setSteps(steps: StepComponent[] | null, activeIndex: number = 0): void {
    this.steps = steps || [];
    this.maxStepIndexVisited.set(activeIndex);
  }

  updateActiveStep(stepper: Stepper, selectedIndex: number, activeIndex: number): void {
    if (!this.isAccessibleStep(selectedIndex, activeIndex)) {
      return;
    }

    if (selectedIndex > this.maxStepIndexVisited()) {
      this.maxStepIndexVisited.set(selectedIndex);
    }
    stepper.updateActiveStep(null, selectedIndex);
  }

  private isAccessibleStep(selectedIndex: number, activeIndex: number): boolean {
    // if not existing step is selected
    if (selectedIndex < 0 || selectedIndex >= this.steps?.length) {
      return false;
    }

    // if one of previous steps is selected
    if (selectedIndex < activeIndex) {
      return true;
    }

    // the next step is selected
    if (selectedIndex === activeIndex + 1) {
      const isValid = this.isValidControl(activeIndex);
      if (!isValid) {
        this.updateControlState(activeIndex);
      }
      return isValid;
    }

    // if step was visited before
    if (selectedIndex <= this.maxStepIndexVisited()) {
      const isValid = this.isValidControl(activeIndex);
      if (!isValid) {
        this.updateControlState(activeIndex);
        return false;
      }
      return this.isValidControls(activeIndex + 1, this.maxStepIndexVisited() - 1);
    }

    return false;
  }


  private isValidControl(index: number): boolean {
    const control = this.getControl(index);
    return control ? control.valid : true;
  }

  private isValidControls(startIndex: number, endIndex: number): boolean {
    let counter = startIndex;
    while (counter <= endIndex) {
      if (!this.isValidControl(counter)) {
        return false;
      }
      counter++;
    }
    return true;
  }

  private updateControlState(index: number): void {
    this.getControl(index)?.markAllAsTouched();
    this.getControl(index)?.markAsDirty();
  }

  private getControl(index: number): AbstractControl | null {
    return this.steps[index]?.control() || null;
  }
}
